import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '@/components/ui/alert-dialog';
import { Shield } from 'lucide-react';

export default function SensitiveActionHelp({ action, onConfirm, children, disabled }) {
  if (!action) return children;
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild disabled={disabled}>
        {children}
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-sm">
            <Shield className="w-4 h-4 text-amber-600" /> {action.title}
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="text-xs space-y-2">
              <span className="block font-medium text-amber-700">{action.warning}</span>
              <span className="block">{action.details}</span>
              {action.costNote && <span className="block text-[#94A3B8] italic">{action.costNote}</span>}
              {action.audited && <span className="block text-[10px] text-[#94A3B8]">Esta acción queda registrada en auditoría.</span>}
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="text-xs">Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="text-xs">Confirmar</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
